import { BadgeCheck, Star } from "lucide-react";

/**
 * Three concise 5★ quotes shown directly beside the Add to Cart card.
 *
 * Why: the full Reviews marquee lives further down the page — most mobile
 * shoppers never scroll to it. Repeating three contextual quotes at the
 * exact decision moment lifts conversion without adding another section.
 *
 * The three picks map to the three main pack sizes so a shopper eyeing any
 * pack sees a buyer like them. Keep this list in sync with the backend
 * buyer-confirmation email's REVIEW_QUOTES block (notifications.py).
 */
export const REVIEW_SNIPPETS = [
  { name: "Priya R.", text: "4-pack covers the car, the caravan, my bike and the toolbox. No subscription is what sold me.", tag: "4 Tracksy", city: "Melbourne" },
  { name: "Sarah M.", text: "One on the ute chassis, one on the box trailer. Setup took under a minute in Find My and the magnet holds solid on the drawbar.", tag: "2 Tracksy", city: "Brisbane" },
  { name: "Tom W.", text: "Runs a landscaping crew — mowers, trailers, generators. Having a tag on each saves me phone calls every week.", tag: "8 Tracksy", city: "Perth" },
];

const SnippetCard = ({ review }) => (
  <div data-testid={`review-snippet-${review.tag.replace(/\s+/g, "-").toLowerCase()}`} className="rounded-2xl border border-black/5 bg-white p-4 shadow-subtle">
    <div className="flex items-center justify-between">
      <span className="flex text-tracksy-orange">
        {[...Array(5)].map((_, i) => (
          <Star key={i} className="h-3.5 w-3.5 fill-current" />
        ))}
      </span>
      <span className="rounded-full bg-tracksy-cream px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest text-tracksy-sub">
        {review.tag}
      </span>
    </div>
    <p className="mt-3 text-sm leading-relaxed text-tracksy-ink">"{review.text}"</p>
    <div className="mt-3 flex items-center gap-2 text-xs">
      <span className="flex h-7 w-7 items-center justify-center rounded-full bg-tracksy-orange font-heading text-[11px] font-extrabold text-white">
        {review.name[0]}
      </span>
      <span className="font-bold text-tracksy-ink">{review.name}</span>
      <span className="text-tracksy-sub">· {review.city}</span>
      <span className="ml-auto flex items-center gap-1 text-tracksy-green">
        <BadgeCheck className="h-3.5 w-3.5" />
        Verified
      </span>
    </div>
  </div>
);

const ReviewSnippets = () => (
  <div data-testid="review-snippets" className="mt-8">
    <div className="mb-3 flex items-end justify-between gap-3">
      <div>
        <p className="text-xs font-bold uppercase tracking-widest text-tracksy-orange">What buyers say</p>
        <p className="font-heading text-lg font-bold text-tracksy-ink">Thousands of utes, trailers and tool-boxes equipped.</p>
      </div>
      <div className="flex items-center gap-2 text-xs font-bold text-tracksy-ink">
        <span className="flex text-tracksy-orange">
          {[...Array(5)].map((_, i) => <Star key={i} className="h-3.5 w-3.5 fill-current" />)}
        </span>
        4.8 avg
      </div>
    </div>
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
      {REVIEW_SNIPPETS.map((r) => (
        <SnippetCard key={r.name} review={r} />
      ))}
    </div>
  </div>
);

export default ReviewSnippets;
